export default {
  '保存成功':'保存成功',
  '总日程表':'总日程表',
  '日程明细表':'日程明细表',
  '单项日程明细表':'单项日程明细表',
  '报名列表':'报名列表',
  '第':'第',
  '组':'组',
  '编排成功':'编排成功',
  '分组成功':'分组成功',
  '取消编排':'取消编排',
  '取消编排成功':'取消编排成功',
  '配置成功':'配置成功',
  '编排列表':'编排列表',
  '运动会积分列表':'运动会积分列表',
  '运动会明细列表':'运动会明细列表',
  '记录管理列表':'记录管理列表',
  '记录导入模板':'记录导入模板',
  '结束成功':'结束成功',
  '日程表':'日程表',
  '生成时间':'生成时间',
  '重新生成日程表':'重新生成日程表',
  '总日程表导出':'总日程表导出',
  '日程明细导出':'日程明细导出',
  '导出':'导出',
  '序号已重复':'序号已重复',
  '分组单位':'分组单位',
  '赛次':'赛次',
  '组数':'组数',
  '人数':'人数',
  '地点':'地点',
  '时间':'时间',
  '重新生成日程表后原数据将清空':'重新生成日程表后原数据将清空',
  '序号不能重复，请检查':'序号不能重复，请检查',
  '运动员列表':'运动员列表',
  '请选择分组单位':'请选择分组单位',
  '组别':'组别',
  '请选择组别':'请选择组别',
  '分组状态':'分组状态',
  '请选择分组状态':'请选择分组状态',
  '已分组':'已分组',
  '未分组':'未分组',
  '请输入运动员姓名或学籍号搜索':'请输入运动员姓名或学籍号搜索',
  '清空编排':'清空编排',
  '自动分组':'自动分组',
  '取消分组':'取消分组',
  '晋级方式':'晋级方式',
  '跑道编号':'跑道编号',
  '运动员背心编码':'运动员背心编码',
  '跑道编号':'跑道编号',
  '请选择跑道编号':'请选择跑道编号',
  '请选择编码':'请选择编码',
  '每组人数':'每组人数',
  '请输入每组人数':'请输入每组人数',
  '每组队伍数':'每组队伍数',
  '请输入每组队伍数':'请输入每组队伍数',
  '是否跨班级':'是否跨班级',
  '是否跨年级':'是否跨年级',
  '区分男女生':'区分男女生',
  '跨分组单位组号重置':'跨分组单位组号重置',
  '最后两组数量均分':'最后两组数量均分',
  '均分':'均分',
  '不均分':'不均分',
  '生成分组':'生成分组',
  '修改学生编排信息':'修改学生编排信息',
  '组内编号':'组内编号',
  '请选择组内编号':'请选择组内编号',
  '仅查看未被占用的编号':'仅查看未被占用的编号',
  '若编号被占用，则编号互换':'若编号被占用，则编号互换',
  '成员名单':'成员名单',
  '批量导入将清空自动分组数据':'批量导入将清空自动分组数据',
  '运动员姓名':'运动员姓名',
  '运动员编码':'运动员编码',
  '成员':'成员',
  '设置编排条件':'设置编排条件',
  '轮晋':'轮晋',
  '轮':'轮',
  '前':'前',
  '名':'名',
  '请输入':'请输入',
  '请选择编排方式':'请选择编排方式',
  '请选择运动员编码':'请选择运动员编码',
  '请选择序号':'请选择序号',
  '请填写每组人数':'请填写每组人数',
  '人数不能大于跑道编号！':'人数不能大于跑道编号！',
  '人数不能大于编码数量！':'人数不能大于编码数量！',
  '请选择跑道':'请选择跑道',
  '注意：若修改上轮成绩或报名信息，将影响已有的编排，旧的编排数据将被覆盖':'注意：若修改上轮成绩或报名信息，将影响已有的编排，旧的编排数据将被覆盖',
  '注意：分组条件发生了变化，将清空现有编排数据':'注意：分组条件发生了变化，将清空现有编排数据',
  '继续将清除现有数据':'继续将清除现有数据',
  '确认要清空编排吗？':'确认要清空编排吗？',
  '确认要取消分组吗？':'确认要取消分组吗？',
  '报名信息导入完成':'报名信息导入完成',
  '批量报名导入失败列表':'批量报名导入失败列表',
  '编排信息导入完成':'编排信息导入完成',
  '运动会编排模板':'运动会编排模板',
  '文件':'文件',
  '批量成绩导入失败列表':'批量成绩导入失败列表',
  '成绩导入完成':'成绩导入完成',
  '运动会成绩模板':'运动会成绩模板',
  '名次':'名次',
  '分值':'分值',
  '破纪录':'破纪录',
  '若有多轮比赛，仅以决赛成绩为准':'若有多轮比赛，仅以决赛成绩为准',
  '一':'一',
  '二':'二',
  '三':'三',
  '四':'四',
  '五':'五',
  '六':'六',
  '七':'七',
  '八':'八',
  '九':'九',
  '十':'十',
  '十一':'十一',
  '十二':'十二',
  '十三':'十三',
  '十四':'十四',
  '十五':'十五',
  '十六':'十六',
  '十七':'十七',
  '十八':'十八',
  '十九':'十九',
  '二十':'二十',
  '明细列表':'明细列表',
  '轮次':'轮次',
  '无效':'无效',
  '有效':'有效',
  '违规':'违规',
  '不违规':'不违规',
  '是否有效':'是否有效',
  '是否违规':'是否违规',
  '班级名称模糊搜索':'班级名称模糊搜索',
  '姓名，学籍号模糊搜索':'姓名，学籍号模糊搜索',
  '新增记录':'新增记录',
  '清空数据':'清空数据',
  '团体赛':'团体赛',
  '个人赛':'个人赛',
  '项目类型':'项目类型',
  '记录等级':'记录等级',
  '校级':'校级',
  '年级':'年级',
  '请选择年级':'请选择年级',
  '请选择年级班级':'请选择年级班级',
  '男生':'男生',
  '女生':'女生',
  '记录':'记录',
  '创造者':'创造者',
  '所属单位':'所属单位',
  '导入记录':'导入记录',
  '记录信息导入完成':'记录信息导入完成',
  '项目不能为空':'项目不能为空',
  '记录等级不能为空':'记录等级不能为空',
  '性别不能为空':'性别不能为空',
  '记录不能为空':'记录不能为空',
  '记录填写错误':'记录填写错误',
  '创造者不能为空':'创造者不能为空',
  '编辑记录':'编辑记录',
  '新增记录':'新增记录',
  '是否删除此条记录？':'是否删除此条记录？',
  '是否清空记录？':'是否清空记录？',
  '确认后，数据将不可恢复':'确认后，数据将不可恢复',
  '数据删除成功':'数据删除成功',
  '编辑记录成功':'编辑记录成功',
  '新增记录成功':'新增记录成功',
  '项目奖':'项目奖',
  '积分奖':'积分奖',
  '其他奖项':'其他奖项',
  '电子章管理':'电子章管理',
  '打印':'打印',
  '注意：因模板格式问题，奖状内容部分仅支持1':'注意：因模板格式问题，奖状内容部分仅支持1-3行，不足或超出时，页面信息将会错位，请打印前确认。',
  '注意：因模板格式问题，奖状内容部分仅支持2行，不足或超出时，页面信息将会错位，请打印前确认。':'注意：因模板格式问题，奖状内容部分仅支持2行，不足或超出时，页面信息将会错位，请打印前确认。',
  '注意：仅支持上传PNG格式的图片，比例为：1':'注意：仅支持上传PNG格式的图片，比例为：1:1',
  '电子章':'电子章',
  '配置':'配置',
  '奖状主体':'奖状主体',
  '获奖主体':'获奖主体',
  '请输入获奖主体':'请输入获奖主体',
  '运动会名称':'运动会名称',
  '请输入运动会名称':'请输入运动会名称',
  '比赛轮次':'比赛轮次',
  '请选择比赛轮次':'请选择比赛轮次',
  '奖项名称':'奖项名称',
  '请选择奖项名称':'请选择奖项名称',
  '获奖内容':'获奖内容',
  '请输入获奖内容':'请输入获奖内容',
  '请输入奖项名称':'请输入奖项名称',
  '获奖名次':'获奖名次',
  '请选择获奖名次':'请选择获奖名次',
  '颁奖机构':'颁奖机构',
  '请输入颁奖机构':'请输入颁奖机构',
  '颁奖日期':'颁奖日期',
  '请选择颁奖日期':'请选择颁奖日期',
  '请选择电子章':'请选择电子章',
  '生成奖状':'生成奖状',
  '新增电子章':'新增电子章',
  '名称':'名称',
  '请输入电子章名称':'请输入电子章名称',
  '点击上传图片':'点击上传图片',
  '支持上传比1':'支持上传比1:1比例的PNG图片，2M以内',
  '请选择项目名称':'请选择项目名称',
  '请上传对应的电子章':'请上传对应的电子章',
  '请选择奖状主体':'请选择奖状主体',
  '请输入颁奖日期':'请输入颁奖日期',
  '个人积分':'个人积分',
  '班级积分':'班级积分',
  '请上传图片':'请上传图片',
  '电子章最多10个':'电子章最多10个',
  '只能导入格式为png格式的文件！':'只能导入格式为png格式的文件！',
  '图片已损坏':'图片已损坏',
  '是否需要删除选中的电子章？':'是否需要删除选中的电子章？',
  '请选择需要删除的电子章':'请选择需要删除的电子章',
  '积分列表':'积分列表',
  '规则说明':'规则说明',
  '积分规则配置':'积分规则配置',
  '生成积分':'生成积分',
  '上次生成时间':'上次生成时间',
  '修改':'修改',
  '积分记录':'积分记录',
  '1、成绩相同则名次相同，如：第1名和第2名成绩相同，将会产生两个第1名，后续名次为第3名。以此类推。':'1、成绩相同则名次相同，如：第1名和第2名成绩相同，将会产生两个第1名，后续名次为第3名。以此类推。',
  '2、若同时有多个相同名次，则每位运动员获得的积分计算公式为：相同名次运动员所占用名次的积分之和':'2、若同时有多个相同名次，则每位运动员获得的积分计算公式为：相同名次运动员所占用名次的积分之和/运动员数量，得出每位运动员积分值，如：第1名加10分，第二名加8分，若有两个第1名，则每位运动员增加的积分为：（10+8）/2=9分，以此类推。',
  '积分修改':'积分修改',
  '加减分数':'加减分数',
  '积分':'积分',
  '积分来源':'积分来源',
  '确认要重新生成积分吗？':'确认要重新生成积分吗？',
  '继续将清除现有积分数据':'继续将清除现有积分数据',
  '积分修改成功':'积分修改成功',
  '分数不能为空':'分数不能为空',
  '备注不能为空':'备注不能为空',
  '加减分数最高只能为':'加减分数最高只能为',
  '加减分数最低只能为':'加减分数最低只能为',
  '详情':'详情',
  '报名':'报名',
  '编排':'编排',
  '记录管理':'记录管理',
  '明细':'明细',
  '证书':'证书',
  '项目列表':'项目列表',
  '查看日程表':'查看日程表',
  '项目配置':'项目配置',
  '赛制':'赛制',
  '比赛方式':'比赛方式',
  '请选择该项目的比赛轮次，如预赛、决赛则选择2':'请选择该项目的比赛轮次，如预赛+决赛则选择2',
  '最多四个字':'最多四个字',
  '排名赛':'排名赛',
  '团队赛':'团队赛',
  '田赛':'田赛',
  '径赛':'径赛',
  '组内':'组内',
  '本轮参赛者':'本轮参赛者',
  '请选择赛制':'请选择赛制',
  '请选择比赛方式':'请选择比赛方式',
  '该填写完整':'该填写完整',
  '无编排数据！':'无编排数据！',
  '附标题':'附标题',
  '请输入附标题':'请输入附标题',
  '请上传比例为1':'请上传比例为1:1且小于5M的PNG、JPG格式图片',
  '报名时间':'报名时间',
  '比赛时间':'比赛时间',
  '赛事文件':'赛事文件',
  '正在上传':'正在上传',
  '上传文件':'上传文件',
  '未上传文件':'未上传文件',
  '50M以内；支持扩展名：':'50M以内；支持扩展名：.xlsx、.docx、.pdf',
  '每人限报数量':'每人限报数量',
  '修改后不影响已经报名的数据':'修改后不影响已经报名的数据',
  '范围':'范围',
  '班级报名人数':'班级报名人数',
  '为空时，不限制人数':'为空时，不限制人数',
  '队伍人数':'队伍人数',
  '请输入标题':'请输入标题',
  '请选择报名时间':'请选择报名时间',
  '请选择开始时间':'请选择开始时间',
  '请选择结束时间':'请选择结束时间',
  '请选择比赛时间':'请选择比赛时间',
  '比赛时间不得早于报名结束时间':'比赛时间不得早于报名结束时间',
  '请选择':'请选择',
  '跑道':'跑道',
  '运动员成绩批量导出':'运动员成绩批量导出',
  '运动会列表':'运动会列表',
  '请输入运动会名称关键字':'请输入运动会名称关键字',
  '新增运动会':'新增运动会',
  '运动风采':'运动风采',
  '确认要删除该运动会：{name}':'确认要删除该运动会：{name}吗？',
  '删除后将无法查看本运动会数据':'删除后将无法查看本运动会数据',
  '确认要提前结束该运动会：':'确认要提前结束该运动会：',
  '确认要提前结束该运动会：{name}':'确认要提前结束该运动会：{name}吗？',
  '运动会结束后不再支持学生运动':'运动会结束后不再支持学生运动',
  '运动风采展示':'运动风采展示',
  '全部选中':'全部选中',
  '运动风采':'运动风采',
  '照片上传':'照片上传',
  '只能导入格式为png、jpg、jpeg格式的文件，单张照片大小不超过20M，历史导入最多不超过100张。':'只能导入格式为png、jpg、jpeg格式的文件，单张照片大小不超过20M，历史导入最多不超过100张。',
  '上传成功数量：':'上传成功数量：',
  '上传失败数量：':'上传失败数量：',
  '正在加载压缩文件':'正在加载压缩文件',
  '风采':'风采',
  '正在压缩':'正在压缩',
  '压缩完成':'压缩完成',
  '文件压缩失败':'文件压缩失败',
  '是否需要删除选中的图片？':'是否需要删除选中的图片？',
  '请选择需要删除的运动风采':'请选择需要删除的运动风采',
  '导入失败，每个运动会最多支持100张图片！':'导入失败，每个运动会最多支持100张图片！',
  '部分导入成功':'部分导入成功',
  '导入失败':'导入失败',
  '导入成功':'导入成功',
  '图片已损坏':'图片已损坏',
  '编排方式':'编排方式',
  '跑道数量':'跑道数量',
  '请选择跑道数量':'请选择跑道数量',
  '编码':'编码',
  '重新分组将覆盖原有分组数据，是否重新分组？':'重新分组将覆盖原有分组数据，是否重新分组？',
  '确认要取消编排吗？':'确认要取消编排吗？',
  '姓名、学籍号、编号模糊搜索':'姓名、学籍号、编号模糊搜索',
  '运动会报名导入模板':'运动会报名导入模板',
  '运动员编号':'运动员编号',
  '参赛项目':'参赛项目',
  '确认移除 {name}的报名信息吗':'确认移除 {name}的报名信息吗？',
  '该编号已经被使用':'该编号已经被使用',
  '删除运动员':'删除运动员',
  '请选择运动员':'请选择运动员',
  '添加项目':'添加项目',
  '请选择运动会时间':'请选择运动会时间',
  '项目已有编排或报名数据，请清除相应数据后再移除。':'项目已有编排或报名数据，请清除相应数据后再移除。',
  '请勿重复选择相同项目。':'请勿重复选择相同项目。',
  '最佳成绩':'最佳成绩',

  // 2026.5.22
  '取消将清空表单内容':'取消将清空表单内容',
  '基本信息':'基本信息',
  '副标题':'副标题',
  '计分方式':'计分方式',
  '班级集体赛':'班级集体赛',
  '班级团队赛':'班级团队赛',
  '参赛班级':'参赛班级',
  '班级参赛人数':'班级参赛人数',
  '运动员已有成绩上报不可移除':'运动员已有成绩上报不可移除',
  '是否移除该运动员':'是否移除该运动员？',
  '移除后将同步清除该运动员编排信息其他编排数据不变':'移除后将同步清除该运动员编排信息，其他编排数据不变',
  '新增报名':'新增报名',
  '输入完整学籍号搜索':'输入完整学籍号搜索',
  '班级个人汇总':'班级个人汇总',
  '班级个人最佳':'班级个人最佳',
  '班级个人平均':'班级个人平均',
  '请选择计分方式':'请选择计分方式',
  '运动强度':'运动强度',
  '选择项目':'选择项目',
  '运动方式':'运动方式',
  '强度':'强度',  
  '不限制':'不限制',
  '学籍号不能为空':'学籍号不能为空',
  '同班同组':'同班同组',
  '已存在编排数据请清空后导入':'已存在编排数据，请清空后导入',
  '导出全量数据':'导出全量数据',
  '运动会明细总表':'运动会明细总表',
  '作废':'作废',
  '取消作废':'取消作废',
  '是否取消作废该记录':'是否取消作废该记录？',
  '是否作废该记录':'是否作废该记录？',
  '取消后该成绩将置为有效':'取消后，该成绩将置为有效',
  '作废后成绩将置为无效':'作废后成绩将置为无效',
  '是否取消':'是否取消？',
  '编号':'编号',
  '未搜索到运动员':'未搜索到运动员',

  // 2026.6.24 
  '编排条件设置':'编排条件设置',
  '注意请确认当前编排的轮次是否正确':'注意：请确认当前编排的轮次是否正确',
  '分组规模':'分组规模',
  '背心号码':'背心号码',
  '道次':'道次',
  '分组单位生成规则':'分组单位生成规则',
  '运动员仅在同一分组单位内排名不跨分组单位比较':'运动员仅在同一分组单位内排名，不跨分组单位比较',
  '分组规则':'分组规则',
  '性别':'性别',
  '区分男女':'区分男女',
  '男女混合':'男女混合',
  '评比范围':'评比范围',
  '组号':'组号',
  '按分组单位重新编号':'按分组单位重新编号',
  '连续编号':'连续编号',
  '末组均分':'末组均分',
  '最后两组人数均分':'最后两组人数均分',
  '组内运动员分配':'组内运动员分配',
  '班级内评比':'班级内评比',
  '年级内评比':'年级内评比',
  '全校评比':'全校评比',
  '仅同班同组':'仅同班同组',
  '优先同班同组':'优先同班同组',
  '仅同班不同组':'仅同班不同组',
  '优先同班不同组':'优先同班不同组',
  '随机分配':'随机分配',
  '成绩优异者居中':'成绩优异者居中',
  '道次分配':'道次分配',
  '背心号码分配':'背心号码分配',
  '序号分配':'序号分配',

}
